<script>
    window.scrollTo(0, 0);

    import {push, querystring} from "svelte-spa-router";
    import {order} from "../../js/stores";
    import {onMount} from "svelte";
    import {fromBase64} from "js-base64";

    const REDIRECT_URI = `https://payments.comgate.cz/client/instructions/index?id=`

    // TODO chytat a updatovat objednávku z URI (base64)
    onMount(async () => {
        const urlParams = new URLSearchParams($querystring)

        if (urlParams.has("order")) {
            order.set(fromBase64(urlParams.get('order')))
        }

        if ($order === null) {
            return await push("/")
        }

        setTimeout(() => {
            window.location.assign(REDIRECT_URI + $order.payment_id)
        }, 5000)
    })
</script>

<section class="container">
    <div class="order">
        <div class="row">
            <div class="offset-xl-3 col-xl-6">
                <div class="order-header">
                    <div class="row d-none d-md-flex">
                        <div class="col-2">
                            <div class="header-number checked">
                                <h1>1</h1>
                                <span>súhrn</span>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="line"></div>
                        </div>
                        <div class="col-2">
                            <div class="header-number checked">
                                <h1>2</h1>
                                <span>dodacie údaje</span>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="line"></div>
                        </div>
                        <div class="col-2">
                            <div class="header-number active">
                                <h1>3</h1>
                                <span>dokončenie</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-body">
                    <div class="order-created">
                        <i class="far fa-fw fa-check-circle"></i>
                        <h2>Objednávka s číslom <span>#{$order?.order_id}</span> bola vytvorená!</h2>
                        <p>Za chvíľu Vás presmerujeme na platobnú bránu. Pokiaľ dlho k presmerovaniu nedôjde, <a href={REDIRECT_URI + $order?.payment_id}>kliknite tu</a>.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    .order-created {
        text-align: center;
        background-color: rgba(0, 0, 0, 0.1);
        padding: 3rem;
        border-radius: 30px;
    }
    .order-created i {
        color: #33CF3D;
        font-size: 6rem;
        margin-bottom: 1rem;
    }
    .order-created h2 {
        font-family: Rubik, sans-serif;
        font-weight: 500;
    }
    .order-created h2 span {
        color: #1A7ABA;
    }
    .order-created p {
        font-family: Rubik, sans-serif;
        font-weight: 300;
    }
    .order-created ul {
        list-style-type: none;
        padding-left: 0;
        margin-top: 5rem;
        font-family: Rubik, sans-serif;
        font-weight: 300;
    }
    .order-created ul li {
        color: rgba(0, 0, 0, 0.5);
        text-align: left;
    }
    .order-created ul li span:last-child {
        float: right;
    }
    .order-body .order-check:nth-child(3) {
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        padding-bottom: 1rem;
    }

    .order-payment {
        color: #000000;
        padding-top: 1rem;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
    }
    .order-payment h2 {
        font-family: Rubik, sans-serif;
        font-weight: 500;
        font-size: 1.3rem;
    }
    .order-payment .payment-list {
        margin-top: 0.5rem;
    }
    .order-payment .payment-item {
        padding: 1rem 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        color: rgba(0, 0, 0, 0.5);
        transition: 0.2s;
    }
    .order-payment .payment-item:first-child {
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
    .order-payment .payment-item:last-child {
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
    .order-payment .payment-item.focused {
        color: black;
        transition: 0.2s;
    }
    .order-payment .payment-item i {
        color: black !important;
    }
    .order-payment .payment-item .payment-radio {
        display: block;
        position: relative;
        cursor: pointer;
        user-select: none;
        margin-top: 0;
        margin-right: 2rem;
    }
    .order-payment .payment-item .payment-radio input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }
    .order-payment .payment-item .payment-radio .checkmark {
        position: absolute;
        top: -3px;
        left: 0;
        height: 25px;
        width: 25px;
        background-color: #eee;
        border-radius: 50%;
    }
    .order-payment .payment-item .payment-radio:hover input ~ .checkmark {
        background-color: #ccc;
    }
    .order-payment .payment-item .payment-radio input:checked ~ .checkmark {
        background-color: #1A7ABA;
    }
    .order-payment .payment-item .payment-radio .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }
    .order-payment .payment-item .payment-radio input:checked ~ .checkmark:after {
        display: block;
    }
    .order-payment .payment-item .payment-radio .checkmark:after {
        top: 8.8px;
        left: 8.7px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: white;
    }
</style>